import React from "react";

/**
 * Brand mark — the official DAIONE logo.
 *
 * Variants:
 *   - "icon"     : square logo lockup (silver D + DAIONE on cool-blue gradient badge)
 *   - "wordmark" : full stacked logo (D + DAIONE + tagline TRAIN. TRACK. TRANSFORM.)
 *   - "inline"   : icon badge only (no extra text — "DAIONE" is already baked into the lockup)
 *
 * Sizes given in px. The brand assets live in /public.
 */
export default function BrandMark({
  variant = "inline",
  size = 32,
  className = "",
  // Kept for backwards compat with old callers; ignored in the new inline lockup.
  textClassName: _textClassName,
  showText: _showText,
}) {
  if (variant === "wordmark") {
    return (
      <img
        src="/logo-wordmark.png"
        alt="DAIONE — Train. Track. Transform."
        height={size}
        style={{ height: size, width: "auto" }}
        className={className}
        data-testid="brand-wordmark"
      />
    );
  }

  // "icon" and "inline" both render the rounded D+DAIONE lockup badge.
  return (
    <img
      src="/logo-icon.png"
      alt="DAIONE"
      width={size}
      height={size}
      style={{ width: size, height: size, borderRadius: Math.round(size * 0.22) }}
      className={className}
      data-testid={variant === "icon" ? "brand-icon" : "brand-inline"}
    />
  );
}
